var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./Sidebar.scss";
import { t } from '@mp/locale';
import PropertyInfoReview from '../Review/PropertyInfoReview';
import AppointmentReview from '../Review/AppointmentReview';
import Surcharge from '../Review/Surcharge';
import SummaryReview from '../Review/SummaryReview';
export default function PriceEstimate(_a) {
    var order = _a.order;
    return (_jsxs("div", __assign({ className: "mp-sidebar" }, { children: [_jsx("h3", __assign({ className: "mp-sidebar-main-title" }, { children: t("CAPTURE_SERVICES.ORDER.REVIEW.PROPERTY_SECTION.estimatedPrice") })), _jsx(PropertyInfoReview, { order: order, sidebar: true }), _jsx(AppointmentReview, { order: order, sidebar: true }), _jsx(Surcharge, { order: order }), _jsx(SummaryReview, { order: order, sidebar: true })] })));
}
